
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { UPDATE_CONSIGNMENT, GET_CONSIGNMENT_DETAILS_BY_NUMBER, GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN, GET_STAKEHOLDER_BASIC_DETAILS_URN, GET_USER_DETAILS, } from '../../../common/URLs'
import moment from 'moment';
import { ADD_POPOVER, BASIC_DATE_FORMAT, CANCEL_POPOVER, EMPTY_FIELD_ERROR, SUBMIT_API, UPDATE_POPOVER, UPLOAD_FILE_TEXT, VEHICLE_INSURANCE, VEHICLE_NATIONAL_PERMIT, VEHICLE_PUCC, WEIGHT_ERROR } from '../../../common/constants';
import { PROD } from '../../../common/constants';
import { Container, Card, Button, CardContent, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { DataGrid } from '@mui/x-data-grid';
import { getLocalStorageItem } from '../../../common/localStorageUtils';

import { toast } from 'react-toastify';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction } from '../../../common/commonValidations';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from "react-i18next";
import apiClient from '../../../axios';

export const UpdateConsignmentPopup = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [consDetail, setConsDetail] = useState(props?.row)
    const [vehicleList, setVehicleList] = useState([]);
    const [stakeHolder, setStakeHolder] = useState([]);
    const [vehicleNo, setVehicleNo] = useState("");
    const [vehicleNoError, setVehicleNoError] = useState("");
    const [vehicleCapacity, setVehicleCapacity] = useState("");
    const [vehicleCapacityError, setVehicleCapacityError] = useState("");
    const [consignmentDetails, setConsignmentDetails] = useState();

    const [driverName, setDriverName] = useState("");
    const [driverNameError, setDriverNameError] = useState("");
    const [driverList, setDriverList] = useState([]);
    const [driverlicensenumber, setDriverlicensenumber] = useState("");
    const [driverlicensenumberError, setDriverlicensenumberError] = useState("");
    const [driverContact, setDriverContact] = useState("");
    const [driverContactError, setDriverContactError] = useState("");

    const [comments, setComments] = useState("");
    const [updateResponse, setUpdateResponse] = useState();

    const [characterLimit] = useState(500);
    const [addComment, setAddComment] = useState('');

    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalOpen1 = () => setLogModalOpen(true);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => setLogModalOpen2(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);


    const columns = [
        { field: 'pickUpLocationName', headerName: 'Scheduled Pick-Up Location', width: 270 },
        { field: 'deliveryLocationName', headerName: 'Delivery Location', width: 250 },
        { field: 'scheduleWeight', headerName: 'Balance Quantity (MT)', width: 150 },
    ];

    const onTextValueChange = (e) => {
        setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
    }

    useEffect(() => {
        if (consDetail) {
            getConsignmentDetails();
            getDriverDetails();

        }
    }, [consDetail]);

    useEffect(() => {
        if (consignmentDetails) {
            setDriverName(consignmentDetails?.driverName)
            setVehicleNo(consignmentDetails?.vehicleRegNo)
            setDriverlicensenumber(consignmentDetails?.driverLicenseNo)
            setDriverContact(consignmentDetails?.driverContact)
            setVehicleCapacity(consignmentDetails?.vehicleCapacity)
            setAddComment(consignmentDetails?.consignmentComments)
        }
    }, [consignmentDetails]);

    const getConsignmentDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
                {
                    "consignmentNumber": consDetail.consignmentNumber,
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setConsignmentDetails(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });

    }
    const getDriverDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDERS_VEHICLE_DRIVER_BY_URN,
                {
                    "urn": consDetail?.consignmentOwner,
                    "type": consDetail?.consignmentOwnerType
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setDriverList(response.data.driverList);
                setVehicleList(response.data.vehicleList);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    }

    const onConfirm = () => {
        handleConfirmClose();
        updateConsignmentDetails();
        props.onClose()
        // handleSave();
    }

    const onSaveButtonClick = () => {
        handleConfirmOpen();
    }

    const onSave = (e) => {
        onSaveButtonClick();
        // updateConsignmentDetails();
        // props.onClose()
    }

    const updateConsignmentDetails = () => {
        loaderService.showLoader();
        apiClient
            .post(UPDATE_CONSIGNMENT,
                {
                    "consignmentNo": consignmentDetails.consignmentNo,
                    "consignmentWeight": consignmentDetails?.consignmentWeight,
                    "vehicleRegNo": vehicleNo,
                    "driverName": driverName,
                    "driverLicenseNo": driverlicensenumber,
                    "driverContact": driverContact,
                    "vehicleCapacity": vehicleCapacity,
                    "consignmentComments": addComment
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUpdateResponse(response.data)
                toast.success(response.data.message);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });

    }

    const updateVehicleDetails = (e) => {
        e.target.value.length > 0 && setVehicleNoError("");
        setVehicleNo(e.target.value);
        let vehicleSelected = vehicleList.filter(vehicle => vehicle.registrationNo === e.target.value)
        setVehicleCapacity(vehicleSelected[0].grossVehicleWeight)
    }
    const updateDriverDetails = (e) => {
        e.target.value.length > 0 && setDriverlicensenumberError("");
        setDriverlicensenumber(e.target.value);
        let driverSelected = driverList.filter(driver => driver.driverLicenseId === e.target.value)
        setDriverName(driverSelected[0].driverName);
        setDriverContact(driverSelected[0].driverContactNo);
    }
    return (
        <>
            <Container maxWidth="xxl">
                {/* {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT65</p>} */}
                <Typography variant="h5" gutterBottom>
                    Update Consignment Details
                </Typography>
                <Card>
                    <CardContent>
                        <Box style={{ height: 162, width: '100%' }}>

                            <DataGrid
                                rows={[consDetail]}
                                getRowId={(row) => row?.consignmentNumber}
                                columns={columns}
                                hideFooterPagination
                            />

                        </Box>
                        <Grid container spacing={2} direction="row" mt={1}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel>Vehicle Number</InputLabel>
                                            <Select
                                                label="Vehicle Number"
                                                // name=''
                                                onChange={(e) => updateVehicleDetails(e)}
                                                value={vehicleNo} >
                                                {vehicleList?.map(row =>
                                                    <MenuItem selected value={row.registrationNo}>{row.registrationNo}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel>Driver License Number</InputLabel>
                                            <Select
                                                label="Driver License Number"
                                                // name=''
                                                value={driverlicensenumber}
                                                onChange={(e) => { updateDriverDetails(e) }} >
                                                {driverList?.map(row =>
                                                    <MenuItem selected value={row.driverLicenseId}>{row.driverLicenseId}</MenuItem>
                                                )}

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth label="Driver Contact" disabled value={driverContact} onChange={(e) => { e.target.value.length > 0 && setDriverContactError(""); setDriverContact(e.target.value) }} type="text" />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth label="Vehicle Capacity" value={vehicleCapacity || ''} onChange={(e) => { e.target.value.length > 0 && setVehicleCapacityError(""); setVehicleCapacity(e.target.value) }} type="text" InputProps={{ maxLength: 6 }} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth label="Driver Name" disabled value={driverName} onChange={(e) => { e.target.value.length > 0 && setDriverNameError(""); setDriverName(e.target.value) }} type="text" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            autoComplete="off"
                                            id="outlined-multiline-static"
                                            label={t('reg.comment')}
                                            multiline
                                            inputProps={{ maxLength: 500 }}
                                            // value={comments}
                                            // onChange={(e) => setComments(e.target.value)}
                                            type="text"
                                            onChange={(e) => onTextValueChange(e)}
                                            value={addComment}
                                           
                                        />
                                        <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                                            <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={props.onClose}>Cancel</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onSave(e)}>Save</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirm} onClose={handleConfirmClose} action="Update Consignment Details" />
        </>
    )

}